module.exports = __webpack_public_path__ + "img/1525479375.f346026f.jpg";